export default "__VITE_ASSET__907631eb__"